import { chiangMaiGetYourGuideAttractions } from '../../../config/affiliates/attractions/get-your-guide/chiang-mai';
import { chiangMaiKlookAttractions } from '../../../config/affiliates/attractions/klook/chiang-mai';
import { Content } from '../../types';

export const chiangMaiContent: Content = {
  title: "צ'אנג מאי - בירת הצפון והפנינה התרבותית של תאילנד",
  imageUrl: '/images/thailand/chiang-mai/chiang-mai-wide.jpeg',
  introduction:
    "צ'אנג מאי, בירת הצפון והפנינה התרבותית של תאילנד, הינה עיר קסומה המושכת אליה תיירים מכל העולם בזכות השילוב בין היסטוריה עשירה, תרבות מרתקת, טבע עוצר נשימה ואווירה שלווה ומיוחדת.",
  sections: [
    {
      title: "היכרות עם צ'אנג מאי - בירת הצפון",
      type: 'sub-headers',
      content: [
        {
          subtitle: '',
          text: "צ'אנג מאי, בירת הצפון והפנינה התרבותית של תאילנד, הינה עיר קסומה המושכת אליה תיירים מכל העולם בזכות השילוב בין היסטוריה עשירה, תרבות מרתקת, טבע עוצר נשימה ואווירה שלווה ומיוחדת. העיר שוכנת בעמק ירוק מוקף הרים בגובה של כ-300 מטר מעל פני הים ומציעה חוויית טיול שונה לחלוטין מהערים התוססות של הדרום כמו בנגקוק או פוקט. בצ'אנג מאי תוכלו להתרשם ממקדשים עתיקים, סדנאות אמנות, שווקים תוססים, אוכל רחוב מקומי, תרבות שבטי ההרים והזדמנויות רבות לטיולים ופעילויות בטבע. היא נחשבת גם לבירת הרוחניות של תאילנד, מה שהופך אותה ליעד אידיאלי למטיילים המחפשים חוויה אותנטית ושלווה.",
        },
        {
          subtitle: '',
          text: "צ'אנג מאי נוסדה בשנת 1296 כעיר הבירה של ממלכת לאנה (Lanna), אחת הממלכות החשובות בתולדות דרום-מזרח אסיה. העיר העתיקה, שהייתה מוקפת חומה וחפיר לצורך הגנה מפני פלישות, שומרת על קסמה ההיסטורי עד היום. ברחובותיה העתיקים ניתן למצוא מקדשים בני מאות שנים, סמטאות קסומות ובתי עץ תאילנדיים מסורתיים לצד בתי קפה מודרניים.",
        },
      ],
    },
    {
      title: "טבע ונוף בצ'אנג מאי",
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/chiang-mai/chiang-mai-article-1.jpg',
    },
    {
      title: "מזג אוויר בצ'אנג מאי - מתי כדאי לבקר?",
      description: "צ'אנג מאי נהנית מאקלים טרופי עם שלוש עונות עיקריות:",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'העונה הקרה (נובמבר-פברואר)',
          text: "התקופה הטובה ביותר לביקור בצ'אנג מאי. מזג האוויר נעים עם טמפרטורות של 15-28 מעלות ביום והאוויר יבש. מזג האוויר האידיאלי מושך מטיילים רבים לעיר.",
        },
        {
          subtitle: 'העונה החמה (מרץ-מאי)',
          text: 'מזג האוויר חם ולעיתים חם מאוד, במיוחד במרץ ואפריל. בתקופה זו עלול להופיע זיהום אוויר בשל "עונת השריפות" (burning season), הנגרמות משריפות חקלאיות באזורים ההרריים שמסביב.',
        },
        {
          subtitle: 'העונה הרטובה (יוני-אוקטובר)',
          text: 'מתאפיינת בגשמים תכופים ולעיתים סוערים, אך העיר נשארת ירוקה ומרהיבה. זו תקופה פחות עמוסה תיירים, ולכן מחירי הלינה נוטים להיות נמוכים יותר.',
        },
      ],
      sectionLink: {
        url: '/international/thailand/article/thailand-weather',
        text: 'למדריך המלא אודות מזג האוויר בתאילנד',
      },
    },
    {
      title: "אזורים מומלצים ללינה בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי מציעה מגוון רחב של אזורי לינה, כל אחד עם האווירה והאופי הייחודיים לו:",
      content: [
        {
          subtitle: 'העיר העתיקה',
          text: "אזור הליבה ההיסטורי של צ'אנג מאי, מוקף חומה ותעלת מים רחבה. אידיאלי למעוניינים להיות קרוב למקדשים המרכזיים, שווקי סוף השבוע ובתי קפה מקומיים. האזור שופע גסטהאוסים, מלונות בוטיק ואווירה סופר רגועה.",
        },
        {
          subtitle: 'נימאן (Nimman)',
          text: "שכונה מודרנית מערבית יותר, בקרבת האוניברסיטה, עם שפע של בתי קפה ומקומות בילוי טרנדיים, מסעדות, קניונים ומרחבים יצירתיים. מתאים למעדיפים אווירה אורבנית עם טאץ' צעיר.",
        },
        {
          subtitle: 'נהר הפינג',
          text: 'אזור נעים ומעט שקט יותר לאורך הנהר, מושך זוגות ומשפחות המחפשים שילוב של טבע ועיר. ניתן למצוא כאן מלונות יוקרה, מתחמי ספא ומסעדות שף מול הנוף.',
        },
        {
          subtitle:
            'האזור הכפרי מסביב ובשולי העיר ובכלל זה אזור סאן קאמפנג (San Kamphaeng)',
          text: 'המחפשים שלווה, טבע ושהות באווירה כפרית, יוכלו למצוא וילות, ריזורטים ומלונות בוטיק מחוץ לעיר עצמה, בטבע, בקרבת שמורות טבע, מעיינות חמים וכפרים אותנטיים מהממים.',
        },
      ],
    },
    {
      title: '',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/chiang-mai/chiang-mai-article-2.jpg',
    },
    {
      title: "לינה ייחודית בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "מלבד מלונות ובתי הארחה רגילים, צ'אנג מאי מציעה גם חוויות לינה יוצאות דופן:",
      content: [
        {
          subtitle: 'וילות יוקרתיות מול נוף ההרים',
          text: 'עם בריכות פרטיות מול נופים מהממים, בריחוק מהמולת העיר הגדולה.',
        },
        {
          subtitle: 'Homestay בכפרים',
          text: 'לינה בבית מקומי עם ארוחות וחוויית חיים אותנטית ובסיסית.',
        },
        {
          subtitle: 'בתי עץ אקולוגיים',
          text: 'בלב יערות טבעיים, חיבור מוחלט לטבע.',
        },
      ],
    },
    {
      title: "תחבורה ציבורית והשכרת רכבים בצ'אנג מאי",
      type: 'sub-headers',
      description: "אמצעי התחבורה בצ'אנג מאי מגוונים, נוחים וזולים יחסית:",
      content: [
        {
          subtitle: 'סונגתאו (Songthaew)',
          text: 'טנדר מקומי, לרוב בצבע אדום, עם ספסלים מאחור. אמצעי תחבורה ציבורי למחצה, הפועל על מסלולים קבועים ו/ או לפי בקשת הנוסעים. זול ויעיל בשל זמינותו הרבה.',
        },
        {
          subtitle: 'טוק טוק',
          text: 'כלי רכב קטן לתנועה עירונית מהירה. חוויה תיירותית אותנטית אך לעיתים יקרה יותר.',
        },
        {
          subtitle: 'מוניות גראב (Grab)',
          text: 'אפליקציית מוניות פופולרית ומומלצת, עם מחירים שקופים ובטיחות גבוהה.',
        },
        {
          subtitle: 'השכרת קטנועים',
          text: 'אפשרות נפוצה אך מתאימה בעיקר למנוסים ברכיבה על אופנועים/ קטנועים. חובה להצטייד ברישיון מתאים וביטוח.',
        },
        {
          subtitle: 'השכרת רכב',
          text: "לאלו המתכננים טיולים מחוץ לעיר (כמו לאזור פאי, צ'אנג ראי או דוי אינתהנון) ו/ או למעוניינים בלינה באזורים המרוחקים מהמרכז ובכלל זה בכפרים הסמוכים לעיר, רכב פרטי יהווה יתרון משמעותי וישדרג את הטיול במספר רמות.",
        },
      ],
      displayRentalAffiliate: true,
    },
    {
      title: "דרכי הגעה לצ'אנג מאי",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'בטיסה',
          text: "הדרך המהירה ביותר להגיע לצ'אנג מאי הינה בטיסה מבנגקוק (כ -60 עד 80 דקות). שדות התעופה דון מואנג וסוברנבומי מציעים עשרות טיסות ביום לצ'אנג מאי. ניתן להגיע בטיסות ישירות אף מפוקט, מסאמוי וממקומות נוספים, אם כי בזמינות פחותה יותר.",
        },
        {
          subtitle: 'ברכבת',
          text: 'מסע רכבת נופי מבנגקוק שנמשך בין 10 ל - 14 שעות, מתאים למעוניינים לחוות את תאילנד באיטיות. רכבות לילה עם תאים ממוזגים, הן המומלצות ביותר.',
        },
        {
          subtitle: 'באוטובוס',
          text: 'תחבורה זולה אך איטית יותר. קיימת זמינות לאוטובוסים רגילים או אוטובוסי VIP עם מושבים רחבים ונוחים.',
        },
        {
          subtitle: 'ברכב פרטי',
          text: 'נסיעה של כ - 8 עד 10 שעות מבנגקוק, דרך נופי צפון תאילנד. אפשרות נוחה במיוחד ומעניינת, עבור משפחות או קבוצות.',
        },
      ],
      is12GoBanner: true,
    },
    {
      title: "האם יש חופים בצ'אנג מאי?",
      type: 'text',
      content:
        'צ\'אנג מאי הינה עיר פנימית בצפון תאילנד ואינה ממוקמת על חוף ים, אך ניתן למצוא בסביבתה מקווי מים טבעיים, בריכות אקולוגיות ומפלים בהם ניתן לרחוץ ולבלות, כמו מפלי Buathong (המכונים גם "המפלים הדביקים") ומפלים נוספים בקרבת העיר, מעיינות חמים ואגמים כמו Huay Tung Tao. כמו כן, חלק מהמלונות והריזורטים מציעים בריכות מפנקות עם נוף להרים.',
    },
    {
      title: "טיולי יום ואטרקציות מרכזיות בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי הינה נקודת יציאה אידיאלית לטיולי יום מגוונים ברחבי צפון תאילנד - מהרים ירוקים ועד כפרים אותנטיים, שמורות טבע מרהיבות, מקדשים מבודדים ומפגשים עם תרבויות שבטיות.<br />להלן מדריך אודות היעדים והאטרקציות המומלצות לטיולי יום מהעיר:",
      content: [
        {
          subtitle: 'דוי אינתהנון (Doi Inthanon)',
          text: "ההר הגבוה ביותר בתאילנד (2,565 מטר) נמצא במרחק של כשעה וחצי נסיעה מצ'אנג מאי, בתוך פארק לאומי הקרוי על שמו. בפארק הלאומי, תוכלו לטייל בשבילי נוף ביער גשם עבות, לבקר במפלים עוצרי נשימה (כמו מפל Wachirathan), ליהנות מהנוף הפנורמי בפסגה, לבקר בפגודות המלכותיות (פגודות המלך והמלכה) ולטייל בכפרי השבטים המקומיים ואף ללון ביחידות האירוח (Homestay) בכפרים. בחורף אף ייתכנו טמפרטורות קרות במיוחד - חווייה נדירה בתאילנד.",
          link: {
            url: chiangMaiGetYourGuideAttractions['doi-inthanon'],
            text: 'לחצו כאן ובדקו את דוי אינתהנון בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'ואט פרה תאט דוי סוטפ (Wat Phra That Doi Suthep)',
          text: "מקדש מרשים, החשוב ביותר בצ'אנג מאי והממוקם בפסגת שמורת טבע בעלת אותו שם. המקדש משקיף על העיר ולאחר שטיפסתם כ-300 מדרגות (או עליתם בקרונית), תקבלו תצפית פנורמית מרהיבה על העיר. מלבד המקדש המפורסם, האזור כולל מסלולי הליכה ביערות, מפלים קטנים, אתרי קמפינג וכפרים של שבטי ההרים כמו שבט המונג בכפר דוי פוי (Hmong Doi Pui), שם תוכלו ללמוד על אורח החיים המקומי ובכלל זה, אודות עבודות היד המקומיות. ניתן לשלב במסגרת טיול זה אף ביקור במפל Montha Than.",
          link: {
            url: chiangMaiGetYourGuideAttractions['doi-suthep'],
            text: 'לחצו כאן ובדקו את ואט פרה תאט דוי סוטפ בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle:
            "העיר העתיקה ומקדשיה - כולל ואט צ'די לואנג (Wat Chedi Luang)",
          text: 'מקדש עתיק מהמאה ה-14 שבו שכן בעבר פסל בודהה האזמרגד, ואט פרה סינג (Wat Phra Singh) - ביתו של פסל בודהה החשוב "פרא סינג" ומרכז בודהיסטי חשוב בעיר, ואט פאן טאו ועוד. סיור רגוע ומעניין בין סמטאות עתיקות, מבנים בודהיסטיים עתיקים ובתי קפה, מסעדות וחנויות שונות בעלות גוון אותנטי מאוד. מומלץ לסייר ביום זה באמצעות אופניים אותן ניתן לשכור ברחבי העיר העתיקה.',
          link: {
            url: chiangMaiGetYourGuideAttractions['half-day-old-town'],
            text: "לחצו כאן ובדקו את הטיול בעיר העתיקה בצ'אנג מאי בעצמכם",
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'חוות פילים שיקומיות וטיפוליות',
          text: "באזור צ'אנג מאי קיימות חוות אתיות להצלת פילים וטיפול בהם, בהן ניתן ללמוד על הפילים ולטפל בהם (האכלה, רחיצה, הליכה ועוד), מתוך חוויה אמיתית למבקרים ולפילים עצמם, ללא רכיבה כמובן:<br />✓ <strong>Kanta Elephant Sanctuary</strong><br />✓ <strong>Elephant Nature Park</strong><br />✓ <strong>Elephant Jungle Sanctuary</strong><br />✓ <strong>Kindred Spirit Elephant Sanctuary</strong>",
          link: {
            url: chiangMaiGetYourGuideAttractions['elephant-sanctuary'],
            text: 'לחצו כאן ובדקו את חוות הפילים השיקומית בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'העמק הנסתר של מהא קאמפונג (Mae Kampong)',
          text: "כפר הררי אותנטי בלב יערות ירוקים, במרחק של כשעה וחצי מצ'אנג מאי. המקום מציע טיולים רגליים, מפלים, מעיינות חמים, קפה מקומי ושהות באווירה כפרית שלווה. אידיאלי למחפשים חוויה מקומית אותנטית ורגועה.",
          link: {
            url: chiangMaiGetYourGuideAttractions['mae-kampong-village'],
            text: 'לחצו כאן ובדקו את העמק הנסתר של מהא קאמפונג בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: "מערת צ'אנג דאו",
          text: "מערכת מערות קרסטיות עצומות הממוקמות צפונית לעיר, מתחת להר המרשים דוי לואנג צ'אנג דאו. ניתן לשלב בטיול זה, טיול רגלי ביער טרופי, ביקור במקדש בודהיסטי, טיול בכפרי הסביבה ובמסעדות הצופות לנוף ההררי.",
          link: {
            url: chiangMaiGetYourGuideAttractions['chiang-dao-cave'],
            text: "לחצו כאן ובדקו את מערת צ'אנג דאו בעצמכם",
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'רפטינג וקיאקים באזור נהר מהא טאנג (Mae Taeng)',
          text: 'לאוהבי אדרנלין, חוויית רפטינג, קיאקים או סאפ בנהר הפראי מהא טאנג, יחד עם ביקור בכפרים של שבטי ההרים. מתאים גם למשפחות עם מתבגרים.',
          link: {
            url: chiangMaiGetYourGuideAttractions['mae-taeng-rafting'],
            text: 'לחצו כאן ובדקו את הרפטינג והקיאקים באזור נהר מהא טאנג בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'עמק מהא רים  (Mae Rim)',
          text: 'טיולי טבע, מפלים ונהרות. טיולים רגליים בטבע בין המפלים השונים, כמו Mae Sa ו-Mok Fa הממוקמים במרחק קצר מהעיר, רכיבה על אופניים, בתי קפה ומסעדות מקומיות לאורך הנהר וביקור בחוות אורכידאות ופרפרים.',
        },
        {
          subtitle: 'חוות, קפה וכפרים באזור סנקאמפנג (San Kamphaeng)',
          text: 'אזור חקלאי מקסים לא רחוק מהעיר, עם חוות פרחים, בתי קפה נוסח כפרי, שדות אורז, תצפיות ירוקות, סדנאות קרמיקה ומעיינות חמים. מקום נפלא ליום רגוע מחוץ להמולת העיר.',
        },
        {
          subtitle: 'מרכזי מלאכות מקומיים',
          text: 'ביקור הכפר המפעלים Bo Sang (מטריות, גילוף בעץ, משי, צביעה ועיטור מזכרות בלכה, קדרות), סדנאות בישול ותכשיטים.',
        },
        {
          subtitle: 'הגן הבוטני המלכותי Queen Sirikit',
          text: 'גנים מטופחים, בעמק מהא רים (Mae Rim) עם חממות טרופיות, גשר תלוי, מסלולי הליכה ונופים.',
        },
        {
          subtitle: "גן החיות של צ'אנג מאי",
          text: 'בית חם לפנדות ולקואלות הענקיות, חיות אקזוטיות נוספות ואקווריום תת-קרקעי מרשים. מדובר על גן חיות ענק הממוקם מערבית לעיר, על הדרך למקדש דוי סוטפ ובו 15 מתחמים וניתן להסתובב בו באמצעות רכב פתוח הנע לאורך מתחמי הגן.',
        },
        {
          subtitle: 'ספארי לילה',
          text: 'פארק ספארי ובו 3 מתחמים, כאשר באחד מהם ניתן לטייל אף בשעות היום ובשניים נוספים, רק בשעות הלילה, כך שמומלץ להגיע למקום כשעתיים קודם לשקיעה, להתחיל במתחם הפתוח בשעות היום ולהמשיך לשני המתחמים הנוספים, בהם מטיילים באמצעות סיור בקרונית פתוחה. בפארק, אף מתקיימים מופעים שונים - עם בעלי החיים, ריקודים, מים ואורות.',
          link: {
            url: chiangMaiKlookAttractions['night-safari-tour'],
            text: 'לחצו כאן ובדקו את ספארי הלילה בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Chiang Mai Grand Canyon',
          text: 'אזור טבעי מלא במים, המתאים לשחייה, קפיצות מצוק ואטרקציות אקסטרים. מתאים מאוד כיום בילוי עבור משפחות עם ילדים.',
          link: {
            url: chiangMaiGetYourGuideAttractions['grand-canyon-water-park'],
            text: 'לחצו כאן ובדקו את הגרנד קניון בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Huay Tung Tao Lake',
          text: 'אגם רגוע בו נוהגים המקומיים לבלות, עם אפשרות להשכרת רפסודות ולארוחה על שפת האגם.',
        },
        {
          subtitle: 'המפלים הדביקים (Buathong Waterfalls)',
          text: 'מפלים ייחודיים אשר בזכות מרקם הסלעים הייחודי, ניתן לטפס עליהם בלי להחליק. חוויית טבע מהנה במיוחד למשפחות וילדים.',
          link: {
            url: chiangMaiGetYourGuideAttractions['sticky-waterfall'],
            text: 'לחצו כאן ובדקו את המפלים הדביקים בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'שבטי ההרים והכפרים הצפוניים',
          text: `ביקור בכפרים של שבטי האקה, קארן או ליסו, מומלץ בליווי מדריך מקומי.
טיולי ג'יפים וטרקים, טיולים בני יומיים-שלושה באזורי ג'ונגל, שינה בכפרים, ראפטינג וטיולים רגליים מודרכים, לכיוון פאי ו/ או צ'אנג ראי. חברות מומלצות עבור טיולים אלו: טאנה ורד בריק.`,
        },
      ],
      tourIds: '748457,124160,816530',
    },
    {
      title: "חוויות וטיולים משפחתיים בצ'אנג מאי",
      type: 'sub-headers',
      description: 'העיר וסביבתה מציעות שלל חוויות המתאימות לילדים ולהורים:',
      content: [
        {
          subtitle: 'Flight of the Gibbon',
          text: 'פארק חבלים ואומגות בלב היער, הרפתקה מרגשת לכל המשפחה. האתר נסגר בתקופת מגיפת הקורונה וטרם נפתח מחדש, במידה וייפתח זהו האתר המומלץ ביותר עבור חוויה זו. Skyline Jungle Luge ו-King Kong Smile Zipline - שני פארקים גדולים עבור חוויית האומגות, המומלצים ביותר בצפון תאילנד, נכון להיום.',
          link: {
            url: chiangMaiGetYourGuideAttractions['zipline-adventure'],
            text: 'לחצו כאן ובדקו את פארק חבלים ואומגות בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Art in Paradise',
          text: 'מוזיאון תלת-ממד אינטראקטיבי המזמין את הילדים והמבוגרים להצטלם בתוך ציורים מרהיבים המייצרים אפקט תלת מימד.',
        },
        {
          subtitle: 'סדנאות בישול משפחתיות',
          text: 'חוויה מהנה, בה כל המשפחה לומדת להכין מנות תאילנדיות אותנטיות. בין בתי הספר המומלצים ניתן למצוא את Mama Noi Cookery School ואת Thai Cookery School.',
        },
        {
          subtitle: 'שייט לאורך הנהר פינג',
          text: 'חוויה משפחתית מומלצת מאוד, במסגרתה ניתן להכיר את חיי התושבים בכפרים לאורך הנהר, לשוחח, להכיר, לשחק עם הילדים ולטעום ממטעמי המטבח התאילנדי, דגש על המנות הייחודיות לצפון תאילנד. חברה מפעילה מומלצת - Mae Ping River Cruise.',
          link: {
            url: chiangMaiGetYourGuideAttractions['ping-river-cruise'],
            text: 'לחצו כאן ובדקו את נהר הפינג בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: "מוזיאונים בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי מציעה מגוון מוזיאונים מרתקים, המתאימים לחובבי תרבות, היסטוריה ואמנות:",
      content: [
        {
          subtitle: "המוזיאון הלאומי של צ'אנג מאי",
          text: 'מלמד על מורשת ממלכת לאנה, התרבות, המסורת והתפתחות האזור.',
        },
        {
          subtitle: 'מוזיאון לאנה לאמנות עממית',
          text: 'מציג את אורח החיים המסורתי של אנשי לאנה דרך תלבושות, כלים, ומיצגים אינטראקטיביים.',
        },
        {
          subtitle: 'מוזיאון האמנות העכשווית (MAIIAM)',
          text: 'חלל מודרני עם תערוכות מתחלפות של אמנים תאילנדים ובינלאומיים.',
        },
        {
          subtitle: 'מוזיאון החרקים והפלאים של הטבע',
          text: 'אטרקציה נהדרת למשפחות עם ילדים, עם אוספים פרטיים נדירים של פרפרים, חיפושיות וחרקים.',
        },
      ],
    },
    {
      title: "חוויות קולינריות ומסעדות מומלצות בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "האוכל בצ'אנג מאי הינו חוויה בפני עצמה, עם מנות מסורתיות ייחודיות לאזור הצפון:",
      content: [
        {
          subtitle: 'מנות מקומיות',
          text: '✓ <strong>קאו סוי (Khao Soi)</strong> - מרק קארי עם אטריות ביצים ובשר, אחד המאכלים המזוהים ביותר עם העיר.<br />✓ <strong>סאי אואה (Sai Oua)</strong> - נקניקיות תאילנדיות מתובלות היטב, מעדן מקומי נפוץ.<br />✓ <strong>פאד תאי בנוסח מקומי</strong> - עטוף בתוך חביתת ביצים בטעם מקומי מיוחד.',
        },
        {
          subtitle: 'מסעדות מומלצות',
          text: '✓ <strong>Khao Soi Khun Yai</strong> - מקום קטן וידוע בעיקר עבור אחת המנות המזוהות ביותר עם צפון תאילנד: קאו סוי.<br />✓ <strong>Dash Teak House Restaurant and Bar</strong> - אווירה ביתית ומטבח תאילנדי קלאסי באחד הבתים העתיקים בעיר.<br />✓ <strong>The Riverside Bar & Restaurant</strong> - מסעדת שף על גדות נהר הפינג עם תפריט מערבי ותאילנדי ומוזיקה חיה.',
        },
        {
          subtitle: 'שווקי אוכל',
          text: 'שווקי הלילה וחנויות אוכל רחוב, בעיקר שווקי הלילה - הקבוע, של הסטודנטים, של יום שבת ושל יום ראשון, הינם חוויה קולינרית מושלמת בזכות המבחר העצום והטעמים העצומים לא פחות.',
        },
      ],
    },
    {
      title: "מרכזי ספא וטיפולי בריאות בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי הינה מוקד עבור טיפולים הוליסטיים ורוחניים. ניתן למצוא כאן מגוון רחב של מרכזי ספא וטיפולים מסורתיים:",
      content: [
        {
          subtitle: 'Fah Lanna Spa',
          text: 'מרכז יוקרתי עטור פרסים המציע טיפולי עיסוי תאילנדי, שמנים ארומטיים ורפלקסולוגיה.',
          link: {
            url: chiangMaiKlookAttractions['fah-lanna-spa'],
            text: 'לחצו כאן ובדקו את Fah Lanna Spa בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Cheeva Spa',
          text: 'פופולרי מאוד בזכות השירות האישי, האווירה הרגועה והעיצוב המוקפד.',
          link: {
            url: chiangMaiKlookAttractions['cheeva-spa'],
            text: 'לחצו כאן ובדקו את Cheeva Spa בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Old Medicine Hospital Thai Massage School Shivagakomarpaj',
          text: 'המקום המושלם עבור המעוניינים ללמוד עיסוי תאילנדי מקצועי.',
        },
      ],
    },
    {
      title: "חיי לילה בצ'אנג מאי",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Nimman Road',
          text: 'אזור בילוי מודרני עם ברים, פאבים ומועדוני לילה בעלי אווירה צעירה ובינלאומית.',
        },
        {
          subtitle: 'Zoe in Yellow',
          text: 'מתחם בילויים פופולרי בלב העיר העתיקה, עם מוזיקה חיה, מסיבות ושתייה זולה.',
        },
        {
          subtitle: 'ברים על הגג (Rooftop Bars)',
          text: 'כמו Rise Bar שבאזור Nimman, מציעים נוף פנורמי, קוקטיילים איכותיים ואווירה יוקרתית.',
        },
        {
          subtitle: 'מופעי תרבות',
          text: 'ניתן ליהנות ממופעי מוזיקה תאילנדית, ריקודים מסורתיים והופעות חיות במסעדות, באולמות קטנים ובשווקי הלילה. מתחם Ploen Ruedee הממוקם בצפון שוק הלילה הקבוע של העיר, הינו מומלץ ביותר עבור חוויה זו.',
        },
      ],
    },
    {
      title: "שווקים בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי מפורסמת בשווקי הלילה שלה, המציעים חווית קניות אותנטית ושפע מוצרים מקומיים. בכל יום תמצאו מספר שווקי לילה, החל משוק הלילה הקבוע ועד שווקים ספציפיים לימים שונים:",
      content: [
        {
          subtitle: "שוק הלילה של צ'אנג מאי (Night Bazaar)",
          text: 'אחד השווקים המפורסמים בתאילנד, פעיל מידי ערב ומציע בגדים, מזכרות, תיקים, עבודות יד ובהן יצירות אמנות ואוכל רחוב.',
        },
        {
          subtitle: 'שוק סוף השבוע של יום ראשון',
          text: 'השוק הגדול והמפורסם ביותר בעיר ולטעמינו, המיוחד והיפה ביותר בתאילנד, מתפרש על הרחוב הראשי של העיר העתיקה Ratchadamnoen St. ומציע חוויה תרבותית עשירה לצד מופעי רחוב.',
        },
        {
          subtitle: 'שוק ווארורוט (Warorot Market)',
          text: 'שוק מקומי הפתוח לאורך היום, אידיאלי למחפשים חווייה אותנטית. בשוק ניתן למצוא תוצרת חקלאית, תבלינים, פירות יבשים, משי תאילנדי, בגדים ועוד.',
        },
        {
          subtitle: 'שוק Ton Lamyai',
          text: 'שוק פרחים ססגוני על גדות נהר הפינג, פתוח 24 שעות.',
        },
      ],
    },
    {
      title: '',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/chiang-mai/chiang-mai-article-3.jpg',
    },
    {
      title: "סדנאות בצ'אנג מאי",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'סדנאות בישול תאילנדי',
          text: 'בהן תלמדו להכין מנות כמו קאו סוי, פאד תאי וקארי תאילנדי. בתי ספר לבישול מומלצים: Mama Noi Cookery School ו-Thai Cookery School.',
          link: {
            url: chiangMaiGetYourGuideAttractions['cooking-class'],
            text: 'לחצו כאן ובדקו את סדנאות בישול תאילנדי בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'סדנאות אמנות ומלאכת יד',
          text: 'בכלל זה גילוף בעץ, הכנת נייר אורז, ציור מסורתי וצביעה בלכה.',
        },
        {
          subtitle: 'סדנאות יוגה ומדיטציה',
          text: 'מרכזים כמו Wild Rose Yoga ו-The Yoga Tree מציעים שיעורי יוגה ומדיטציה למתחילים ולמתקדמים.',
        },
        {
          subtitle: 'עבודה עם פילים',
          text: 'במסגרות מוסריות (כמו Elephant Nature Park), ניתן להצטרף ליום התנדבות חווייתי הכולל האכלה, ניקוי ולימוד.',
        },
      ],
    },
    {
      title: "עבודה, קורסים וריטריטים בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי הינה מוקד עולמי לרוחניות והתפתחות אישית. ניתן למצוא מגוון רחב של ריטריטים, סדנאות ומרכזים המציעים:",
      content: [
        {
          subtitle: 'ריטריטי מדיטציה',
          text: 'כמו Wat Umong או Wat Ram Poeng המציעים שהות של מספר ימים או שבועות ללימוד מדיטציה בודהיסטית (ויפאסנה).',
        },
        {
          subtitle: 'קורסים ביוגה ונשימה',
          text: 'מרכזים כמו Blue Garden Chiang Mai, מציעים שיעורים וריטריטים ביוגה, ונשימה.',
        },
        {
          subtitle: 'מרכזי ריפוי הוליסטיים',
          text: 'טיפולים באנרגיה, הלינג, רפואה סינית ועוד. תמצאו מבחר רב של מרכזים מעין אלו בעיר העתיקה.',
        },
      ],
    },
    {
      title: "אירועים ופסטיבלים שנתיים בצ'אנג מאי",
      type: 'sub-headers',
      description:
        "צ'אנג מאי מארחת במהלך השנה שלל פסטיבלים מרהיבים המספקים הצצה לתרבות הצפון התאילנדי רוויית מסורת, מוסיקה ושמחה. אלו כמה מהם, מרכזיים, שמאוד מומלץ לתכנן את הביקור בסביבת אותו אירוע:",
      content: [
        {
          subtitle: 'לוי קרטונג ו-יי פנג (Yee Peng)',
          text: 'מהפסטיבלים המפורסמים והמרגשים בתאילנד. מתקיים בליל ירח מלא של חודש נובמבר, במהלכו משחררים אלפי פנסי נייר לשמיים ופנסים צפים לנהרות. השמיים הנצבעים באור הפנסים יוצרים מראה בלתי נשכח.',
        },
        {
          subtitle: "פסטיבל הפרחים צ'אנג מאי",
          text: 'בסוף השבוע הראשון של חודש פברואר, עם תהלוכות מרהיבות, מיצגי פרחים, תחפושות ותצוגות אמנות גינון. רחובות העיר מתמלאים בצבעים וריחות לפריחה של ממש.',
        },
        {
          subtitle: 'Songkran - ראש השנה התאילנדי',
          text: "חגיגה עממית ססגונית בחודש אפריל עם מלחמות מים, תפילות במקדשים וטקסי טיהור מקומיים. בצ'אנג מאי, נחגג חג זה בהתלהבות מיוחדת ונמשך מספר ימים.",
        },
        {
          subtitle: 'Inthakin Festival',
          text: "פסטיבל מקומי בסביבות מאי-יוני הנמשך שמונה ימים, בו מביעים תושבי העיר כבוד לפסלי הבודהה. מתקיים במקדש ואט צ'די לואנג עם טקסים, מופעים ושווקים מיוחדים.",
        },
        {
          subtitle: 'פסטיבלים שבטיים',
          text: "בכפרים הסובבים את צ'אנג מאי נערכים מדי פעם פסטיבלים שבטיים (כמו קארן, אקה ומונג), עם מופעים, שווקים ותלבושות פרטיות - חוויה אותנטית במיוחד למעוניינים להעמיק בתרבות.",
        },
      ],
    },
    {
      title: 'טיפים ומידע שימושי למטיילים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'לבוש במקדשים',
          text: 'יש להצטייד בביגוד צנוע למקדשים ולכבד את מנהגי המקום!',
        },
        {
          subtitle: 'השכרת רכב',
          text: "מומלץ מאוד לשכור רכב עבור השהות והטיולים באזור צ'אנג מאי.",
        },
        {
          subtitle: 'אוכל מקומי',
          text: "אוכל הרחוב בצפון תאילנד ככלל ובצ'אנג מאי כפרט הינו ייחודי לאזור. התנסו בו, בעיקר בשווקים השונים!",
        },
        {
          subtitle: 'התמקחות',
          text: 'התמקחו בשווקים - אך באדיבות ובגבולות הטעם הטוב.',
        },
        {
          subtitle: 'שווקים',
          text: 'אל תפספסו את שוק הלילה של יום ראשון בעיר העתיקה!',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        "צ'אנג מאי הינה עיר מרתקת המשלבת בין ישן לחדש, בין טבע פראי לאורבניות נעימה. בין אם הינכם מחפשים חוויות תרבותיות, אוכל משובח, מסלולי טבע או חיי לילה תוססים, העיר מציעה מכל הטוב שבאלו ומזמינה אתכם לגלות את הקסם הייחודי שלה.",
    },
  ],
};
